import { createAction, createReducer } from '@reduxjs/toolkit'

export const fieldUpdateSettingsAction = createAction('global/settings/fieldUpdateSettings')

export const settingsReducer = createReducer(
  {
    orientation: 'horizontal',
    fontSize: '-densityCompact',
    mediaClass: '-media-md',
    theme: '-themeLight',
  },
  (builder) => {
    builder.addCase(fieldUpdateSettingsAction, (state, action) => ({ ...state, ...action.payload }))
  },
)

export const fieldUpdateStatusAction = createAction('global/status/fieldUpdateStatus')
export const clearNoticeStatusAction = createAction('global/status/clearNotice')
export const clearMsgStatusAction = createAction('global/status/clearMsg')

export const statusReducer = createReducer(
  {
    msgLevel: '',
    msgIconUrl: '',
    msgHeader: '',
    msgBody: '',
    noticeLevel: '',
    noticeIconUrl: '',
    noticeHeader: '',
    noticeBody: '',
  },
  (builder) => {
    builder.addCase(fieldUpdateStatusAction, (state, action) => ({ ...state, ...action.payload }))
    builder.addCase(clearNoticeStatusAction, (state) => {
      state.noticeLevel = ''
      state.noticeLevel = ''
      state.noticeIconUrl = ''
      state.noticeHeader = ''
      state.noticeBody = ''
    })
    builder.addCase(clearMsgStatusAction, (state) => {
      state.msgLevel = ''
      state.msgIconUrl = ''
      state.msgHeader = ''
      state.msgBody = ''
    })
  },
)

export const fieldUpdateFeedbackAction = createAction('global/feedback/fieldUpdateFeedback')
export const fieldValidationFeedbackAction = createAction(
  'global/feedback/fieldValidationFeedbackAction',
)


